const TAB_ACTIVE_BORDER = 'border-navy';
const TAB_INACTIVE_BORDER = 'border-transparent';

const updateNavDisabledState = (root, target) => {
  const activePanel = root.querySelector(`.featured-partners__panel[data-panel="${target}"]`);
  const activeNav = root.querySelector(`.featured-partners__nav-group[data-nav="${target}"]`);
  if (!activeNav) return;

  const navButtons = activeNav.querySelectorAll('button');
  const hasSlides = activePanel && activePanel.querySelectorAll('.swiper-slide').length > 0;
  const swiperInstance = activePanel?.querySelector('.swiper')?.swiper;

  navButtons.forEach((button) => {
    if (!hasSlides) {
      button.disabled = true;
      button.classList.add('swiper-button-disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  });
  
  if (hasSlides && swiperInstance?.navigation) {
    swiperInstance.navigation.update();
  }
};

const initFeaturedPartnersRoot = (root) => {
  const tabs = root.querySelectorAll('.featured-partners__tab-btn');
  const panels = root.querySelectorAll('.featured-partners__panel');
  const navGroups = root.querySelectorAll('.featured-partners__nav-group');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.getAttribute('data-target');
      if (!target) return;

      tabs.forEach((item) => {
        item.classList.remove(TAB_ACTIVE_BORDER);
        item.classList.add(TAB_INACTIVE_BORDER);
        item.setAttribute('aria-selected', 'false');
      });

      tab.classList.remove(TAB_INACTIVE_BORDER);
      tab.classList.add(TAB_ACTIVE_BORDER);
      tab.setAttribute('aria-selected', 'true');

      panels.forEach((panel) => {
        if (panel.getAttribute('data-panel') === target) {
          panel.classList.remove('!hidden');
          const swiperEl = panel.querySelector('.swiper');
          if (swiperEl?.swiper) swiperEl.swiper.update();
        } else {
          panel.classList.add('!hidden');
        }
      });

      navGroups.forEach((group) => {
        if (group.getAttribute('data-nav') === target) {
          group.classList.remove('!hidden');
        } else {
          group.classList.add('!hidden');
        }
      });

      updateNavDisabledState(root, target);
    });
  });

  const activeTab = root.querySelector('.featured-partners__tab-btn[aria-selected="true"]');
  if (activeTab) {
    activeTab.classList.remove(TAB_INACTIVE_BORDER);
    activeTab.classList.add(TAB_ACTIVE_BORDER);
    updateNavDisabledState(root, activeTab.getAttribute('data-target'));
  }
};

const initFeaturedPartners = () => {
  document
    .querySelectorAll('[data-featured-partners]:not([data-featured-partners-init])')
    .forEach((root) => {
      root.dataset.featuredPartnersInit = 'true';
      initFeaturedPartnersRoot(root);
    });
};

export default initFeaturedPartners;
